module.exports = __webpack_public_path__ + "ENG_SPT3-Window_225003111-d585d1f5c5d39c03bbb92a7b4b49ba30.png";